module.exports = __webpack_public_path__ + "918cdde60d4c3c01d900e553d176c2a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_logo.png
// module id = kNCo
// module chunks = 0